<template>
    <crud-facecade
        :url="url"
        :columns="columnList"
        :buttons="[]"
        :tableHeight="tableHeight"
        v-wechat-title="title"
        :addButton="{ permission: 'menu:create' }"
        :deleteButton="{ enabled: false, permission: 'default' }"
        :updateButton="{ enabled: false, permission: 'default' }"
    >
    </crud-facecade>
</template>

<script>
import { mapGetters } from 'vuex'
import componentDefinition from '@/components/componentDefinition'
export default {
    name: `Menu`,
    data() {
        return {
            title: `菜单管理`,
            menuList: []
        }
    },
    created() {},
    computed: {
        ...mapGetters([`enum_menus`, `sys_enums`, `screenHeight`]),
        tableHeight() {
            return this.screenHeight && (this.screenHeight - 190) || 0
        },
        url() {
            return {
                baseURL: `/api/AcisSystem/Menu`
            }
        },
        locations() {
            let r = _.reduce(
                componentDefinition,
                function(result, value, key) {
                    result.push({ value: key.toLowerCase(), label: value.location, jianpin: value.label })
                    return result
                },
                []
            )
            // console.log(r)
            return r
        },
        columnList() {
            return [
                {
                    type: `string`,
                    prop: `id`,
                    label: `ID`,
                    isListable: false,
                    isExpand: false,
                    isEditable: false,
                    isCreatable: false,
                    isKey: true
                },
                {
                    type: `number`,
                    prop: `display_order`,
                    label: `排序`,
                    width: `180`,
                    isListable: true,
                    isExpand: false,
                    isEditable: false,
                    isCreatable: false,
                    readonly: false,
                    sortable: true,
                    isDisplayOrder: true
                },
                {
                    type: `icons`,
                    prop: `icon`,
                    label: `图标`,
                    width: `60`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    options: `menu_icons`
                },
                {
                    type: `string`,
                    prop: `name`,
                    label: `名称`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `string`,
                    prop: `description`,
                    label: `描述`,
                    // width: "180",
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `select`,
                    prop: `business_level`,
                    label: `菜单业务`,
                    // width: "180",
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    options: `enum_business`,
                    default: `M000`,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `string`,
                    prop: `url`,
                    label: `访问路径`,
                    // width: "180",
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true
                },
                {
                    type: `select`,
                    prop: `location`,
                    label: `物理路径`,
                    // width: "180",
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    options: this.locations
                },
                {
                    type: `select`,
                    prop: `parent_id`,
                    label: `父级`,
                    width: `120`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    sortable: true,
                    meta: {
                        parents: this.enum_menus
                    },
                    options: function(that, { row, column, area }) {
                        if (area == `form`) {
                            return _.filter(column.meta.parents, function(d) {
                                return d.value !== row.origion.id
                            })
                        } else {
                            return column.meta.parents
                        }
                    },
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    default: 0
                },
                {
                    type: `rbool`,
                    prop: `is_deleted`,
                    label: `状态`,
                    width: `70`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    sortable: false,
                    readonly: false,
                    options: `is_enabled`,
                    default: false
                },
                {
                    type: `select`,
                    prop: `is_eject`,
                    label: `是否弹出`,
                    width: `120`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    sortable: true,
                    options: `is_using`,
                    default: 0
                },
                {
                    type: `buttongroup`,
                    prop: `oper`,
                    label: `操作`,
                    width: `120`,
                    readonly: false,
                    fixed: `right`,
                    isListable: true,
                    options: [
                        {
                            class: `is-plain`,
                            label: `编辑`,
                            type: `primary`,
                            emit: `LoadingUpdateView`,
                            permission: `default` // user:assignRole
                        },
                        {
                            class: `is-plain`,
                            label: `删除`,
                            type: `danger`,
                            emit: `DeleteData`,
                            permission: `default` // user:assignRole
                        }
                    ]
                }
            ]
        }
    },
    method: {}
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Menu/Index.vue